import React, { useContext } from 'react';
import FacetBar from '@cat/facet-bar';
import { PageDataContext } from '../../providers/page-data-provider';

const LeftHandFacets = (): JSX.Element => {
  const { facetData } = useContext(PageDataContext);

  return (
    <FacetBar
      appliedFacets={facetData.appliedFacets}
      facets={facetData.facetOptions}
      key="scrollable-facet-bar"
    />
  );
};

export default LeftHandFacets;
